/**
 * Using bootstrap-date-pack
 *   "name": "bootstrap-datepicker",
 *   "description": "A datepicker for Bootstrap",
 *   "version": "1.9.0",
 *   "license": "Apache-2.0",
 * See : D:\NPMLIBS\bootstrap-datepicker
 * Modified to support Thai year
 */

/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';

const $ = window.$;

export function DateInput(props) {
  const { em, data } = props;
  const { parentSize } = em || {};

  if (!props.app) {
    console.error('`app` property is require for DataInput');
  }

  const floating = em && em.floating ? em.floating : false;
  const groupClass = (floating ? '' : 'row') + ' ' + (em && em.class ? em.class : '');
  const labelClass = floating ? 'label' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;
  const inputClass = (floating ? '' : `col-sm-${parentSize === 'full' ? '10' : '7'}`) + ` text-center`;

  const [objLang, setObjLang] = useState((props.app && props.app.lang) || props.lang || 'th');
  const [selectedDate, setSelectedDate] = useState(null);
  const [initialized, setInitialized] = useState(false);
  const [requestUpdate, setRequestUpdate] = useState(false);

  const handleDefaultChange = useCallback((e) => {
    if (e.target.value === '') {
      setSelectedDate('');
      setRequestUpdate(true);
    }
  }, []);

  const refInput = useRef(null);

  useEffect(() => {
    if (objLang !== ((props.app && props.app.lang) || props.lang || 'th')) {
      setObjLang((props.app && props.app.lang) || props.lang || 'th');
      setInitialized(false);
    }
  }, [objLang, props.app, props.app.lang, props.lang]);

  useEffect(() => {
    if (initialized) return;

    $(refInput.current).datepicker('destroy');

    $(refInput.current)
      .datepicker({
        language: objLang, // props.app.lang || props.lang || 'th',
        format: 'd M yyyy',
      })
      .on('changeDate', (e) => {
        const _date = e.date;
        // _date.setHours(0, 0, 0, 0);

        setSelectedDate(_date);
        setRequestUpdate(true);
      });

    setInitialized(true);
  }, [initialized, objLang, props]);

  useEffect(() => {
    if (!requestUpdate) return;
    if (em.field && props.onChange) {
      props.onChange({
        target: {
          name: em.field,
          value: selectedDate && selectedDate !== '' ? selectedDate.toISOString() : '',
        },
      });
    }

    setRequestUpdate(false);
  }, [em.field, props, requestUpdate, selectedDate]);

  useEffect(() => {
    let _date = (props.data && em && em.field && props.data[em.field]) || '';
    if (_date !== '' && typeof _date !== 'object') _date = new Date(_date);

    // if (typeof _date === 'object') _date.setHours(0,0,0,0);

    if (_date && _date !== '' && refInput.current) $(refInput.current).datepicker('update', _date);
    setSelectedDate(_date);
  }, [em, em.field, props.data]);

  useLayoutEffect(() => {
    // console.info(refInput.current);
    const _name = refInput.current.name;
    if (!_name) return;

    if (!data[_name] || data[_name] === null || data[_name] === '') {
      refInput.current.value = '';
    }
  }, [data]);

  return (
    <div className={`form-group ${groupClass}`}>
      <label className={`${labelClass}`}>{em && em.label ? em.label : 'วันที่'}</label>
      <input
        ref={refInput}
        type="text"
        className={`form-control ${inputClass}`}
        name={em.field}
        // value={(props.data && em.field && props.data[em.field]) || ''}
        placeholder={em.placeholder || ''}
        onKeyDown={em.onKeyDown}
        readOnly={em.readOnly}
        onChange={handleDefaultChange}
        autoComplete="off"
      />
    </div>
  );
}

DateInput.defaultProps = {
  app: { lang: 'en' },
};
